export default "__VITE_ASSET__DLAzjab___"